import { render, staticRenderFns } from "./SocialShare.vue?vue&type=template&id=05003f3a&scoped=true"
import script from "./SocialShare.vue?vue&type=script&lang=js"
export * from "./SocialShare.vue?vue&type=script&lang=js"
import style0 from "./SocialShare.vue?vue&type=style&index=0&id=05003f3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05003f3a",
  null
  
)

export default component.exports